import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PROJECT_MANAGEMENT_URL } from '@insite-store360/shared';

@Injectable({
  providedIn: 'root'
})
export class RegionalReportOverviewService {
  private apiUrl = `${PROJECT_MANAGEMENT_URL}/regional-report-overview`;

  constructor(private http: HttpClient) { }


  getRegionalSummary(years?: number[], countryIds?: number[], targetCurrency?: string, deliveryYears?: number[], page?: number, limit?: number): Observable<any> {
    let params: any = {};
    if (years && years.length > 0) params.years = years.join(',');
    if (countryIds && countryIds.length > 0) params.countryIds = countryIds.join(',');
    if (targetCurrency) params.targetCurrency = targetCurrency;
    if (deliveryYears && deliveryYears.length > 0) params.deliveryYears = deliveryYears.join(',');
    if (page !== undefined) params.page = page.toString();
    if (limit !== undefined) params.limit = limit.toString();
    
    return this.http.get(`${this.apiUrl}/summary`, { params });
  }

  exportSummaryReport(years?: number[], countryIds?: number[], targetCurrency?: string, deliveryYears?: number[]): Observable<Blob> {
    let params: any = {};
    if (years && years.length > 0) params.years = years.join(',');
    if (countryIds && countryIds.length > 0) params.countryIds = countryIds.join(',');
    if (targetCurrency) params.targetCurrency = targetCurrency;
    if (deliveryYears && deliveryYears.length > 0) params.deliveryYears = deliveryYears.join(',');
 
    return this.http.get(`${this.apiUrl}/summary/downloadExcelReport`, { params, responseType: 'blob' });
  }

  exportDetailedReport(years?: number[], countryIds?: number[], targetCurrency?: string, deliveryYears?: number[]): Observable<Blob> {
    let params: any = {};
    if (years && years.length > 0) params.years = years.join(',');
    if (countryIds && countryIds.length > 0) params.countryIds = countryIds.join(',');
    if (targetCurrency) params.targetCurrency = targetCurrency;
    if (deliveryYears && deliveryYears.length > 0) params.deliveryYears = deliveryYears.join(',');
 
    return this.http.get(`${this.apiUrl}/details/downloadExcelReport`, { params, responseType: 'blob' });
  }

  exportStatsReport(years?: number[], countryIds?: number[], targetCurrency?: string, deliveryYears?: number[], metric?: string): Observable<Blob> {
    let params: any = {};
    if (years && years.length > 0) params.years = years.join(',');
    if (countryIds && countryIds.length > 0) params.countryIds = countryIds.join(',');
    if (targetCurrency) params.targetCurrency = targetCurrency;
    if (deliveryYears && deliveryYears.length > 0) params.deliveryYears = deliveryYears.join(',');
    if (metric) params.metric = metric;
 
    return this.http.get(`${this.apiUrl}/stats/downloadExcelReport`, { params, responseType: 'blob' });
  }

  getCategorySummary(years?: number[], categories?: string[], countryIds?: number[], subCategories?: string[], targetCurrency?: string, deliveryYears?: number[]): Observable<any> {
    let params: any = {};
    if (years && years.length > 0) params.years = years.join(',');
    if (categories && categories.length > 0) params.categories = categories.join(',');
    if (countryIds && countryIds.length > 0) params.countryIds = countryIds.join(',');
    if (subCategories && subCategories.length > 0) params.subCategories = subCategories.join(',');
    if (targetCurrency) params.targetCurrency = targetCurrency;
    if (deliveryYears && deliveryYears.length > 0) params.deliveryYears = deliveryYears.join(',');

    return this.http.get(`${this.apiUrl}/category/summary`, { params });
  }

  getProductLineSummary(years?: number[], productLines?: string[], countryIds?: number[], subCategories?: string[], targetCurrency?: string, deliveryYears?: number[], categories?: string[]): Observable<any> {
    let params: any = {};
    if (years && years.length > 0) params.years = years.join(',');
    if (productLines && productLines.length > 0) params.productLines = productLines.join(',');
    if (categories && categories.length > 0) params.categories = categories.join(',');
    if (countryIds && countryIds.length > 0) params.countryIds = countryIds.join(',');
    if (targetCurrency) params.targetCurrency = targetCurrency;
    if (deliveryYears && deliveryYears.length > 0) params.deliveryYears = deliveryYears.join(',');

    return this.http.get(`${this.apiUrl}/category/summary`, { params });
  }

  getCategoryHierarchy(years?: number[], categories?: string[], countryIds?: number[], subCategories?: string[], targetCurrency?: string, deliveryYears?: number[], page?: number, limit?: number): Observable<any> {
    let params: any = {};
    if (years && years.length > 0) params.years = years.join(',');
    if (categories && categories.length > 0) params.categories = categories.join(',');
    if (countryIds && countryIds.length > 0) params.countryIds = countryIds.join(',');
    if (subCategories && subCategories.length > 0) params.subCategories = subCategories.join(',');
    if (targetCurrency) params.targetCurrency = targetCurrency;
    if (deliveryYears && deliveryYears.length > 0) params.deliveryYears = deliveryYears.join(',');
    if (page !== undefined) params.page = page.toString();
    if (limit !== undefined) params.limit = limit.toString();

    return this.http.get(`${this.apiUrl}/category/hierarchy`, { params });
  }

  exportCategoryHierarchy(years?: number[], categories?: string[], countryIds?: number[], subCategories?: string[], targetCurrency?: string, deliveryYears?: number[]): Observable<Blob> {
    let params: any = {};
    if (years && years.length > 0) params.years = years.join(',');
    if (categories && categories.length > 0) params.categories = categories.join(',');
    if (countryIds && countryIds.length > 0) params.countryIds = countryIds.join(',');
    if (subCategories && subCategories.length > 0) params.subCategories = subCategories.join(',');
    if (targetCurrency) params.targetCurrency = targetCurrency;
    if (deliveryYears && deliveryYears.length > 0) params.deliveryYears = deliveryYears.join(',');
 
    return this.http.get(`${this.apiUrl}/category/hierarchy/downloadExcelReport`, { params, responseType: 'blob' });
  }

  getProductLineHierarchy(years?: number[], productLines?: string[], countryIds?: number[], targetCurrency?: string, deliveryYears?: number[]): Observable<any> {
    let params: any = {};
    if (years && years.length > 0) params.years = years.join(',');
    if (productLines && productLines.length > 0) params.productLines = productLines.join(',');
    if (countryIds && countryIds.length > 0) params.countryIds = countryIds.join(',');
    if (targetCurrency) params.targetCurrency = targetCurrency;
    if (deliveryYears && deliveryYears.length > 0) params.deliveryYears = deliveryYears.join(',');

    return this.http.get(`${this.apiUrl}/category/hierarchy`, { params });
  }

  getDistinctCategories(countryIds?: number[]): Observable<any> {
    let params: any = {};
    if (countryIds && countryIds.length > 0) params.countryIds = countryIds.join(',');
    return this.http.get(`${this.apiUrl}/category/filters/categories`, { params });
  }

  getDistinctProductLines(countryIds?: number[]): Observable<any> {
    let params: any = {};
    if (countryIds && countryIds.length > 0) params.countryIds = countryIds.join(',');
    return this.http.get(`${this.apiUrl}/category/filters/product-lines`, { params });
  }

  getDistinctCountries(): Observable<any> {
    return this.http.get(`${this.apiUrl}/category/filters/countries`);
  }

  getModelCTFSummary(models?: string[], countryIds?: number[], years?: number[], targetCurrency?: string, deliveryYears?: number[], page?: number, limit?: number): Observable<any> {
    let params: any = {};
    if (models && models.length > 0) params.models = models.join(',');
    if (countryIds && countryIds.length > 0) params.countryIds = countryIds.join(',');
    if (years && years.length > 0) params.years = years.join(',');
    if (targetCurrency) params.targetCurrency = targetCurrency;
    if (deliveryYears && deliveryYears.length > 0) params.deliveryYears = deliveryYears.join(',');
    if (page !== undefined) params.page = page.toString();
    if (limit !== undefined) params.limit = limit.toString();

    return this.http.get(`${this.apiUrl}/model/ctf-summary`, { params });
  }

  getModelPerformance(models?: string[], countryIds?: number[], years?: number[], targetCurrency?: string, deliveryYears?: number[], page?: number, limit?: number): Observable<any> {
    let params: any = {};
    if (models && models.length > 0) params.models = models.join(',');
    if (countryIds && countryIds.length > 0) params.countryIds = countryIds.join(',');
    if (years && years.length > 0) params.years = years.join(',');
    if (targetCurrency) params.targetCurrency = targetCurrency;
    if (deliveryYears && deliveryYears.length > 0) params.deliveryYears = deliveryYears.join(',');
    if (page !== undefined) params.page = page.toString();
    if (limit !== undefined) params.limit = limit.toString();

    return this.http.get(`${this.apiUrl}/model/performance`, { params });
  }

  getDistinctModels(countryIds?: number[]): Observable<any> {
    let params: any = {};
    if (countryIds && countryIds.length > 0) params.countryIds = countryIds.join(',');
    return this.http.get(`${this.apiUrl}/model/distinct-models`, { params });
  }

  exportModelCTFSummary(models?: string[], countryIds?: number[], years?: number[], targetCurrency?: string, deliveryYears?: number[]): Observable<Blob> {
    let params: any = {};
    if (models && models.length > 0) params.models = models.join(',');
    if (countryIds && countryIds.length > 0) params.countryIds = countryIds.join(',');
    if (years && years.length > 0) params.years = years.join(',');
    if (targetCurrency) params.targetCurrency = targetCurrency;
    if (deliveryYears && deliveryYears.length > 0) params.deliveryYears = deliveryYears.join(',');
 
    return this.http.get(`${this.apiUrl}/model/ctf-summary/downloadExcelReport`, { params, responseType: 'blob' });
  }

  exportModelPerformance(models?: string[], countryIds?: number[], years?: number[], targetCurrency?: string, deliveryYears?: number[]): Observable<Blob> {
    let params: any = {};
    if (models && models.length > 0) params.models = models.join(',');
    if (countryIds && countryIds.length > 0) params.countryIds = countryIds.join(',');
    if (years && years.length > 0) params.years = years.join(',');
    if (targetCurrency) params.targetCurrency = targetCurrency;
    if (deliveryYears && deliveryYears.length > 0) params.deliveryYears = deliveryYears.join(',');
 
    return this.http.get(`${this.apiUrl}/model/performance/downloadExcelReport`, { params, responseType: 'blob' });
  }

  getDistinctCreatedYears(countryIds?: number[]): Observable<number[]> {
    let params: any = {};
    if (countryIds && countryIds.length > 0) params.countryIds = countryIds.join(',');
    return this.http.get<number[]>(`${PROJECT_MANAGEMENT_URL}/analytical-dashboard/distinct-created-years`, { params });
  }

  getDistinctTargetDeliveryYears(countryIds?: number[]): Observable<number[]> {
    let params: any = {};
    if (countryIds && countryIds.length > 0) params.countryIds = countryIds.join(',');
    return this.http.get<number[]>(`${PROJECT_MANAGEMENT_URL}/analytical-dashboard/distinct-target-delivery-years`, { params });
  }

  getDeliveryByModel(countryIds?: number[], models?: string[], categories?: string[], targetCurrency?: string, deliveryYears?: number[], page?: number, limit?: number): Observable<any> {
    let params: any = {};
    if (countryIds && countryIds.length > 0) params.countryIds = countryIds.join(',');
    if (models && models.length > 0) params.models = models.join(',');
    if (categories && categories.length > 0) params.categories = categories.join(',');
    if (targetCurrency) params.targetCurrency = targetCurrency;
    if (deliveryYears && deliveryYears.length > 0) params.deliveryYears = deliveryYears.join(',');
    if (page !== undefined) params.page = page.toString();
    if (limit !== undefined) params.limit = limit.toString();

    return this.http.get(`${this.apiUrl}/model/delivery-by-model`, { params });
  }

  exportDeliveryByModel(countryIds?: number[], models?: string[], categories?: string[], targetCurrency?: string, deliveryYears?: number[]): Observable<Blob> {
    let params: any = {};
    if (countryIds && countryIds.length > 0) params.countryIds = countryIds.join(',');
    if (models && models.length > 0) params.models = models.join(',');
    if (categories && categories.length > 0) params.categories = categories.join(',');
    if (targetCurrency) params.targetCurrency = targetCurrency;
    if (deliveryYears && deliveryYears.length > 0) params.deliveryYears = deliveryYears.join(',');

    return this.http.get(`${this.apiUrl}/model/delivery-by-model/downloadExcelReport`, { params, responseType: 'blob' });
  }
}





